import { EntityRepository, Repository } from "typeorm";
import { SaleInspectionDetails } from "../so-inspections.entity";

@EntityRepository(SaleInspectionDetails)
export class SaleInspectionDetailsRepository extends Repository<SaleInspectionDetails>{

}